const navHeader = document.querySelector(".header");

// Scrol Navigation
function scrollNavigation() {
   if (document.body.scrollTop > 300 || document.documentElement.scrollTop > 200) {
      navHeader.classList.add('header--scroll');
   } else {
      navHeader.classList.remove('header--scroll');
   }
}

window.onscroll = () => scrollNavigation();


// Dropdown
const dropdownButtons = document.querySelectorAll('.navigation__btn-dropdown');

dropdownButtons.forEach(button => {
  const submenuId = button.getAttribute('aria-controls');
  const submenu = document.getElementById(submenuId);

  // Standard: Menü ist geschlossen
  button.setAttribute('aria-expanded', 'false');

  // Öffnen bei Leertaste oder Enter
  button.addEventListener('keydown', (event) => {
    if (event.code === 'Space' || event.code === 'Enter') {
      event.preventDefault(); // verhindert Scrollen bei Space
      submenu.classList.add('navigation__submenu--show');
      button.setAttribute('aria-expanded', 'true');
      submenu.querySelector('a, button')?.focus(); // Fokus ins Menü setzen
    }
  });

  // Schließen bei Escape
  submenu.addEventListener('keydown', (event) => {
    if (event.code === 'Escape') {
      submenu.classList.remove('navigation__submenu--show');
      button.setAttribute('aria-expanded', 'false');
      button.focus(); // Fokus zurück auf Button
    }
  });

  // Optional: Schließen, wenn Fokus ganz rausgeht
  submenu.addEventListener('focusout', (event) => {
    if (!submenu.contains(event.relatedTarget) && event.relatedTarget !== button) {
      submenu.classList.remove('navigation__submenu--show');
      button.setAttribute('aria-expanded', 'false');
    }
  });
});
